import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 1,
      title: "Nova Calculadora",
      description: "Calcular custos de impressão",
      icon: "Calculator",
      color: "primary",
      path: "/calculator"
    },
    {
      id: 2,
      title: "Adicionar Impressora",
      description: "Registrar nova impressora",
      icon: "Plus",
      color: "secondary",
      path: "/printer-management"
    },
    {
      id: 3,
      title: "Gerenciar Filamentos",
      description: "Controlar estoque",
      icon: "Package",
      color: "success",
      path: "/filament-inventory"
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <h2 className="text-lg font-semibold text-foreground mb-6">Ações Rápidas</h2>
      <div className="space-y-4">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant="outline"
            fullWidth
            onClick={() => handleActionClick(action?.path)}
            className="justify-start p-4 h-auto hover:border-primary/30 group"
          >
            <div className="flex items-center space-x-4 w-full">
              <div className={`
                p-2 rounded-lg transition-colors
                ${action?.color === 'primary' ? 'bg-primary/10 text-primary group-hover:bg-primary/20' : ''}
                ${action?.color === 'secondary' ? 'bg-secondary/10 text-secondary group-hover:bg-secondary/20' : ''}
                ${action?.color === 'success' ? 'bg-success/10 text-success group-hover:bg-success/20' : ''}
              `}>
                <Icon name={action?.icon} size={20} />
              </div>
              
              <div className="flex-1 text-left">
                <div className="font-medium text-foreground group-hover:text-primary transition-colors">
                  {action?.title}
                </div>
                <div className="text-sm text-muted-foreground">
                  {action?.description}
                </div>
              </div>
              
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary transition-colors" 
              />
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;